@if (steps && steps.length) {
  <section class="mobi-ui-section-minor is-large">
    <div class="mobi-ui-process-bar-major">
      @for (step of steps; track step; let i = $index) {
        <div
          class="mobi-ui-process-bar-step-major"
          [class.is-complete]="i < currentPage"
          [class.is-active]="i === currentPage"
          [attr.aria-current]="i === currentPage ? 'step' : null"
        >
          @if (i < currentPage) {
            <button class="mobi-ui-process-bar-link-major" (click)="goTo(i)">
              <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
              <ng-content /><ng-template
                [ngTemplateOutlet]="content"
                [ngTemplateOutletContext]="{ step: step, i: i }"
              ></ng-template>
            </button>
          }
          @if (i >= currentPage) {
            <span class="pointer-events-none mobi-ui-process-bar-link-major">
              <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
              <ng-content /><ng-template
                [ngTemplateOutlet]="content"
                [ngTemplateOutletContext]="{ step: step, i: i }"
              ></ng-template>
            </span>
          }
        </div>
      }
    </div>
  </section>
}

<ng-template #content let-step="step" let-i="i">
  @if (i < currentPage) {
    <mobi-ui-icon-major name="tik_checkbox" />
  } @else {
    <mobi-ui-icon-major [name]="step['#icon']" />
  }
  {{ step['#title'] }}
</ng-template>
